<div class="d-flex breadcrumb-content">
  <ng-container *ngFor="let item of items; let last = last; let i = index">
    <!-- Clickable breadcrumb item -->
    <a 
      *ngIf="item.isActive && item.route" 
      [routerLink]="[item.route]"
      [queryParams]="item.queryParams"
      [state]="item.state"
      class="breadcrumb-link"
    >
      {{ item.name }}
    </a>
    
    <!-- Non-clickable breadcrumb item (current page) -->
    <span 
      *ngIf="!item.isActive" 
      class="text-gray-700"
    >
      {{ item.name }}
    </span>
    
    <!-- Separator (except for the last item) -->
    <span *ngIf="!last" class="mx-1" style="color: #5e5e5e;">/</span>
  </ng-container>
</div> 